module.exports = __webpack_public_path__ + "img/HoldingMoon.c245d855.svg";